export default class EnvManager {
  renderer: any;
  camera: any;
  environments: Record<string, any>;
  currentEnv: any;

  constructor(renderer: any, camera: any) {
    this.renderer = renderer;
    this.camera = camera;
    this.environments = {};
    this.currentEnv = null;
  }

  addEnvironment(name: string, env: any) {
    this.environments[name] = env;
  }

  switchEnvironment(name: string) {
    if (this.currentEnv) {
      this.currentEnv.deactivate();
    }
    this.currentEnv = this.environments[name];
    if (this.currentEnv) {
      this.currentEnv.activate();
    }
  }

  updateWithRender(deltaTime: number) {
    if (this.currentEnv) {
      this.currentEnv.update(deltaTime);
      const threeScene = this.currentEnv.scene.getThreeScene
        ? this.currentEnv.scene.getThreeScene()
        : this.currentEnv.scene.scene;
      this.renderer.render(threeScene, this.camera);
    }
  }
}
